module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isFunction.js
// module id = 27
// module chunks = 0